import React from "react";
import { useFavorites } from "../context/FavoritesContext";
import { useNavigate } from "react-router-dom";
import { filledHeart, emptyHeart } from "../data/icons";

const BreweryItem = ({ brewery, isSelected, showStateButton = false }) => {
    const { favorites, addFavorite, removeFavorite } = useFavorites();
    const navigate = useNavigate();

    const { id, name, city, state, website_url: url } = brewery;

    const isFavorite = favorites.some(fav => fav.id === id);

    const toggleFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            addFavorite(brewery);
        }
    };

    const handleRedirect = () => {
        navigate(`/state/${state}`);
    };

    return (
        <li
            className={`list-group-item pb-2 ${
                isSelected ? "bg-info-subtle" : "bg-white"
            }`}
        >
            <div className="d-flex justify-content-between">
                <div>
                    <h3>{name}</h3>
                    <div>
                        {city}, {state}
                    </div>
                    {url && <div>
                            <a href={url} target="_blank" rel="noreferrer">
                                {url}
                            </a>
                        </div>}
                </div>
                <div>
                    <div className="d-inline-block text-danger fs-2" onClick={toggleFavorite} title={isFavorite ? "Remove from Favorites" : "Add to Favorites"}>
                        {isFavorite ? filledHeart : emptyHeart}
                    </div>
                    {/* <button
                        className="btn btn-sm btn-outline-danger me-2 bg-white"
                        onClick={toggleFavorite}
                    >
                        {isFavorite ? filledHeart : emptyHeart}
                        {isFavorite ? "Remove from Favorites" : "Add to Favorites"}
                    </button> */}
                    {showStateButton && (
                        <button
                            className="btn btn-sm btn-outline-secondary ms-2"
                            onClick={handleRedirect}
                        >
                            View State
                        </button>
                    )}
                </div>
            </div>
        </li>
    );
};

export default BreweryItem;
